define('app/shared/filters/filterDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function filterDirective($timeout, $filter) {
		return {
			restrict: 'E',
			replace: false,
			scope: {
				data: '=data'
			},
			templateUrl: 'app/shared/filters/filter.html',
			link: function(scope, element, attrs) {
				scope.title = attrs.title;
				scope.select = function (item) {
					if (eval(attrs.toggle)) {
						app.field(scope.field).select([item.qElemNumber], true, true);
						console.log("toggle true");
					} else {
						app.field(scope.field).select([item.qElemNumber], false, true);
						app.field('[races.name]', 'rankChartState').selectMatch(item.qText);
					}
				}
				scope.clearInput = function() {
					$timeout(function() {
						element.find("input").val("");
						scope.input = "";
					}, 200);
				}
				scope.$watch('data', function (data) {
					if(!data) return;
					scope.items = _.flatten(scope.data.qDataPages[0].qMatrix);
					scope.field = scope.data.qDimensionInfo.qFallbackTitle;
				}, true);

				
				//Virtual Scroll hack
				element.find("ul").css("height", "108px"); //height set to 5 * height of li, instead of attrs.height
				scope.scrollPosition = 0;
				scope.beginItem = 0;
				scope.endItem = 5;
				scope.top = function (index) {
					return {'top': (index-scope.beginItem)*20+scope.scrollPosition + 'px'};
				}
				$(element).find("ul").scroll(function() {
					scope.scrollPosition = $(this).scrollTop();
					scope.beginItem = scope.scrollPosition / 20;
					scope.endItem = scope.beginItem + 5;
					scope.$apply();
				});
				scope.$watchCollection('filteredItems', function (items) {
					if(!items) return;
					element.find("li:last-child").css("height", items.length*20 + "px").css("width", "1px");
				});
				
			}
		}
	}

	filterDirective.$inject=['$timeout', '$filter'];
  	return filterDirective;
});
